<template>
  <div>
    <div v-if="toEnable2fa">
      <div class="row step-one mb-5">
        <div class="col-5">
          <h2>Step 1 - Get the App</h2>
          <div class="text-center">
            <i class="fab fa-app-store fa-5x mr-3" />
            <i class="fab fa-google-play fa-5x" />
          </div>
        </div>
        <div class="col-7 my-auto">
          <h3>
            Download and install a two-factor app for your phone or tablet. You can search Google Authenticator, Authy
            or Lastpass Authenticator on your mobile or tablet app store.
          </h3>
        </div>
      </div>
      <div class="row step-two mb-5">
        <div class="col-5">
          <h2>Step 2 - Scan this Barcode</h2>
          <div class="text-center">
            <img :src="qrCodeImgUri" />
          </div>
        </div>
        <div class="col-7 my-auto">
          <h3>Open the authentication app and:</h3>
          <ul>
            <li>Tap the "+" icon in the top-right of the app.</li>
            <li>Scan the image to the left, using your phone's camera.</li>
          </ul>
        </div>
      </div>
      <div class="row step-three">
        <div class="col-5">
          <h2>Step 3 - Enter Verification Code</h2>
          <div class="text-center">
            <i class="fas fa-user-lock fa-5x"></i>
          </div>
        </div>
        <div class="col-7 my-auto">
          <h3>Once the above is scanned, enter the 6-digit verification code generated by the app.</h3>
          <b-form>
            <b-form-group class="mb-4">
              <div v-if="error" class="alert alert-danger" role="alert">
                {{ error }}
              </div>
              <b-form-input
                name="authenticationCode"
                v-model="authenticationCode"
                class="text-center code-input mb-3"
                @keydown.enter.prevent="triggerNextStep"
                type="text"
                maxlength="6"
                :formatter="onlyNumberInputIsAllowed"
                placeholder="Enter the code generated by the authenticator app"
              />
            </b-form-group>
          </b-form>
          <b-button
            class="verify-button"
            variant="primary"
            :disabled="shouldDisableButton"
            @click.prevent="triggerNextStep"
          >
            {{ confirmButtonText }}
          </b-button>
        </div>
      </div>
    </div>
    <div v-else>
      <b-form>
        <b-form-group class="mb-4">
          <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
          </div>
          <b-form-input
            name="authenticationCode"
            v-model="authenticationCode"
            class="text-center code-input mb-3"
            @keydown.enter.prevent="triggerNextStep"
            type="text"
            maxlength="6"
            :formatter="onlyNumberInputIsAllowed"
            placeholder="Enter the code generated by the authenticator app"
          />
          <span>Enter the code generated by the authenticator app</span>
        </b-form-group>
      </b-form>
      <div class="row">
        <b-button
          v-if="!hideCancelButton"
          class="col-4 cancel-button"
          variant="primary"
          @click.prevent="$emit('triggerCancel')"
        >
          Cancel
        </b-button>
        <b-button
          class="col-4 verify-button"
          variant="primary"
          :disabled="shouldDisableButton"
          @click.prevent="triggerNextStep"
        >
          {{ confirmButtonText }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TwoFactorAuthentication',
    props: {
      toEnable2fa: {
        type: Boolean,
        default: true
      },
      qrCodeImgUri: {
        type: String,
        default: ''
      },
      error: {
        type: String,
        default: ''
      },
      hideCancelButton: {
        type: Boolean,
        default: false
      },
      confirmButtonText: {
        type: String,
        default: 'Confirm'
      }
    },
    data() {
      return {
        authenticationCode: ''
      }
    },
    computed: {
      shouldDisableButton() {
        return this.authenticationCode.length < 6
      }
    },
    methods: {
      onlyNumberInputIsAllowed(input) {
        return String(input).replace(/[^0-9]/g, '')
      },
      triggerNextStep() {
        const authenticationCode = Number(this.authenticationCode)
        this.$emit('triggerNextStep', { authenticationCode })
      }
    }
  }
</script>
